import { MainContent } from "components/Layout/components/Content";
import { MasterLayout } from "components/Layout/components/MasterLayout";

import { Header } from "../components/Layout/components/Header";
import { HeaderProps } from "../components/Layout/components/Header/Header";

export const NotFound = ({ appTitle, userProfile, username }: HeaderProps) => {
    return (
        <MasterLayout>
            <Header username={username} appTitle={appTitle} userProfile={userProfile} />
            <MainContent id="pageContent">
                <h1>Not found</h1>
            </MainContent>
        </MasterLayout>
    );
};
